import { Saga } from "redux-saga";
import { all, call, spawn } from "redux-saga/effects";
import userSaga from "./user/saga";
import pendingContractSaga from "./pending-contract/saga";
import contractSaga from "./contract/saga";
import claimSaga from "./claim/saga";
import UnRegisterContract from "./unregister-contract/saga";

export default function* rootSaga() {
  const sagas: Saga[] = [
    userSaga,
    pendingContractSaga,
    contractSaga,
    claimSaga,
    UnRegisterContract,
  ];

  yield all(
    sagas?.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error("Saga caught exception:", e);
          }
        }
      })
    )
  );
}
